module.exports = __webpack_public_path__ + "static/media/book-generic.dcd8184b.png";